import script from "./TransactionDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionDetail.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionDetail.vue?vue&type=style&index=0&id=e296ac5e&lang=scss"

const __exports__ = script;

export default __exports__